import React from 'react';
import { Body3Light, Body3Regular } from '@/lib/font';
import { colors } from '@/lib/colors';

type Props = {
    enabled: boolean;
    onEnabledChange: (enabled: boolean) => void;
};

/**
 * 상품의 공유 판매 설정. 허용 여부만 받는다.
 *
 * 인원 한도는 상품마다 정할 값이 아니라 남용 방지 안전값이라 여기서 받지 않고,
 * 저장 시 `DEFAULT_SHARE_POOL_LIMITS`(서버 전역 상한과 동일)를 보낸다.
 * 개별 공유의 한도는 발급 후 수강권 상세의 '인원 한도 변경'에서 조정한다.
 */
const SharePolicyFields = ({ enabled, onEnabledChange }: Props) => (
    <div
        data-testid="shared-membership-policy"
        style={{
            width: 600,
            marginTop: 56,
            marginLeft: 80,
            padding: 20,
            border: '1px solid #DCE6F8',
            borderRadius: 8,
            backgroundColor: '#F7FAFF',
        }}
    >
        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <input
                type="checkbox"
                checked={enabled}
                onChange={(event) => onEnabledChange(event.target.checked)}
                style={{ width: 20, height: 20, marginRight: 12, accentColor: '#1B5AD4' }}
            />
            <Body3Regular style={{ color: colors.LAVEL_4 }}>
                {'공유 수강권으로 판매'}
            </Body3Regular>
        </label>
        <Body3Light style={{ color: colors.LAVEL_1, marginTop: 10, lineHeight: '22px' }}>
            {
                '발급된 총 회차를 여러 회원이 함께 사용합니다. 각 회원에게 회차를 나누어 배정하지 않고, 예약·수업이 처리되는 순서대로 하나의 잔여 회차에서 차감됩니다.'
            }
        </Body3Light>

        {enabled && (
            <Body3Light style={{ color: colors.LAVEL_1, marginTop: 12, lineHeight: '22px' }}>
                {
                    '함께 사용할 회원은 발급 후 수강권 상세에서 추가합니다. 참여 인원 한도는 넉넉한 기본값으로 시작하며, 필요하면 수강권 상세에서 바꿀 수 있습니다.'
                }
            </Body3Light>
        )}
    </div>
);

export default SharePolicyFields;
